import React, { useState, useEffect, useContext } from 'react';
import axiosConfig from '../../../../utils/axiosConfig';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-material-ui';
import {
    Button, Dialog, DialogActions,
    DialogContent, DialogTitle,
    Grid, Slide
} from '@material-ui/core';

import { DispatchContext } from '../../../../context/Provider';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const TopicModal = (props) => {

    const appDispatch = useContext(DispatchContext);
    const { globalDispatch } = appDispatch;

    const [topic, setTopic] = useState({
        title: '',
        sort: ''
    });

    async function createTopic(values, resetForm) {

        const res = await axiosConfig.post(`/topics`, {
            classcode: props.classcode,
            title: values.title,
        });

        if (res.data.status_code === 'ok') {
            globalDispatch({type: 'setSnackbarMsg', value: 'Topic created successfully.'});
            globalDispatch({type: 'setIsOpenSnackbar', value: true});

            props.fetchTopics();
            props.handleClose();

        } else {
            console.log(res);
        }

        globalDispatch({type: 'setIsLoading', value: false});
        setTimeout(() => {
            globalDispatch({type: 'setIsOpenSnackbar', value: false});
        }, 1200);
    }

    async function updateTopic(values, resetForm) {

        const res = await axiosConfig.post(`/topics/${props.topicID}`, {
            _method: 'PATCH',
            title: values.title,
            sort: values.sort
        });

        if (res.data.status_code === 'ok') {
            globalDispatch({type: 'setSnackbarMsg', value: 'Topic updated successfully.'});
            globalDispatch({type: 'setIsOpenSnackbar', value: true});

            props.fetchTopics();
            props.handleClose();
        } else {
            console.log(res);
        }

        globalDispatch({type: 'setIsLoading', value: false});
        setTimeout(() => {
            globalDispatch({type: 'setIsOpenSnackbar', value: false});
        }, 1200);
    }

    useEffect(() => {

        if (props.topicID) {
            setTopic(props.topic);
        }

    }, [props.topicID]);

    return (
        <>
            <Dialog
                open={props.open}
                onClose={props.handleClose}
                aria-labelledby="form-dialog-title"
                fullWidth={true}
                maxWidth={'sm'}
                TransitionComponent={Transition}
                disableBackdropClick
            >
                <Formik
                    initialValues={topic}
                    validate={(values) => {
                        const errors = {};
                        if (!values.title) {
                            errors.title = 'This field is required';
                        }

                        return errors;
                    }}
                    onSubmit={async (values, {setSubmitting, resetForm}) => {
                        globalDispatch({type: 'setIsLoading', value: true});

                        // setTimeout(() => {
                        //     setSubmitting(false);
                        //     alert(JSON.stringify(values, null, 2));
                        //     resetForm();
                        //     globalDispatch({type: 'setIsLoading', value: false});
                        // }, 500);

                        if (props.topicID === null) {
                            await createTopic(values, resetForm);
                        } else {
                            await updateTopic(values, resetForm);
                        }

                        setSubmitting(false);
                    }}
                >
                    {({submitForm, isSubmitting, touched, errors}) => (
                        <Form>
                            <DialogTitle id="form-dialog-title">
                                {props.dialogTitle}
                            </DialogTitle>
                            <DialogContent>
                                <Grid container alignItems="flex-start" spacing={2}>
                                    <Grid item xs={12}>
                                        <Field
                                            component={TextField}
                                            label="Topic Title (required)"
                                            name="title"
                                            fullWidth
                                            variant="outlined"
                                        />
                                    </Grid>

                                    {props.topicID && (
                                        <Grid item xs={12}>
                                            <Field
                                                component={TextField}
                                                label="Sort Order"
                                                name="sort"
                                                type="number"
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={props.handleClose}
                                    disabled={isSubmitting}
                                    color="secondary"
                                >
                                    Cancel
                                </Button>
                                <Button
                                    disabled={isSubmitting}
                                    onClick={submitForm} color="primary"
                                >
                                    Submit
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </>
    );
}

export default TopicModal;